import type { Action } from "redux";

export type BuiltToNotBuiltConfirmationDialogShownEvent = Action<typeof BUILT_TO_NOT_BUILT_CONFIRMATION_DIALOG_SHOWN>

export const builtToNotBuiltConfirmationDialogShown = (): BuiltToNotBuiltConfirmationDialogShownEvent => ({
  type: BUILT_TO_NOT_BUILT_CONFIRMATION_DIALOG_SHOWN
});

export const BUILT_TO_NOT_BUILT_CONFIRMATION_DIALOG_SHOWN = "built_to_not_built_confirmation_dialog_shown";
